// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.core

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.*
import io.github.erkko68.kolt.physics.collision.broadphase.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * Implementation of a JobSystem using a thread pool
 *
 * Note that this is considered an example implementation. It is expected that when you integrate
 * the physics engine into your own project that you'll provide your own implementation of the
 * JobSystem built on top of whatever job system your project uses.
 *
 * C++ `JPH::JobSystemThreadPool`.
 */
class JobSystemThreadPool internal constructor(internal val jobSystemThreadPoolHandle: NativePointer, owned: Boolean = false) : JobSystemWithBarrier(JphJobSystemThreadPool_asJobSystemWithBarrier(jobSystemThreadPoolHandle), owned), AutoCloseable {
    constructor(maxJobs: Int, maxBarriers: Int, numThreads: Int) : this(JphJobSystemThreadPool_create_uint_uint_int(maxJobs, maxBarriers, numThreads), owned = true)
    constructor() : this(JphJobSystemThreadPool_create(), owned = true)

    override fun close() =
        closeOnce { JphJobSystemThreadPool_destroy(jobSystemThreadPoolHandle) }

    fun setThreadInitFunction(initFunction: ((Int) -> Unit)?) =
        run {
            val initFunctionUser = if (initFunction == null) NullPointer else Upcalls.reference(NativeCallback { args, result -> initFunction(readSlot(args, 0).toInt()) })
            JphJobSystemThreadPool_SetThreadInitFunction(jobSystemThreadPoolHandle, Upcalls.function, initFunctionUser)
        }

    fun setThreadExitFunction(exitFunction: ((Int) -> Unit)?) =
        run {
            val exitFunctionUser = if (exitFunction == null) NullPointer else Upcalls.reference(NativeCallback { args, result -> exitFunction(readSlot(args, 0).toInt()) })
            JphJobSystemThreadPool_SetThreadExitFunction(jobSystemThreadPoolHandle, Upcalls.function, exitFunctionUser)
        }

    /**
     * Initialize the thread pool
     * @param maxJobs Max number of jobs that can be allocated at any time
     * @param maxBarriers Max number of barriers that can be allocated at any time
     * @param numThreads Number of threads to start (the number of concurrent jobs is 1 more because the main thread will also run jobs while waiting for a barrier to complete). Use -1 to auto detect the amount of CPU's.
     */
    fun init(maxJobs: Int, maxBarriers: Int, numThreads: Int) =
        JphJobSystemThreadPool_Init(jobSystemThreadPoolHandle, maxJobs, maxBarriers, numThreads)

    /** Change the max concurrency after initialization */
    fun setNumThreads(numThreads: Int) =
        JphJobSystemThreadPool_SetNumThreads(jobSystemThreadPoolHandle, numThreads)
}
